module.exports = __webpack_public_path__ + "static/media/ally-ups-product-img@3x.c035852a.png";